import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo1_03.png'


const _withScopeId = n => (_pushScopeId("data-v-7cf8b750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-container" }
const _hoisted_2 = {
  key: 0,
  class: "head-logo"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo-img"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "head-div"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-shujuzhongxin1",
  style: {"font-size":"1.1rem !important"}
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数据中心", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-shouye",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-rizhi",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-jiekou",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-tixian",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-dailishang-1" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-dailishang-1" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tixian" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-kaifazhongxin-",
  style: {"font-size":"1.1rem !important"}
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开发中心", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-shouye",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-rizhi",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-banbenguanli",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-gonggao",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-gonggao",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-kamiguanli",
  style: {"font-size":"1.1rem !important"}
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卡密管理", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-liebiao",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-kamiguanli1",
  style: {"font-size":"1.1rem !important","margin-right":"8px"}
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-lingquguanggao" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-chaxun" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-tuichu1",
  style: {"margin-right":"7px","margin-left":"3px"}
}, null, -1))
const _hoisted_29 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ( ($setup.isCollapse1 == 1 && $setup.isWindow))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.navigateTo('/'))),
            style: {"margin":"0 auto","padding-top":"20px","width":"fit-content"}
          }, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    ($setup.isCollapse1 != -1 || $setup.isWindow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_el_menu, {
            class: "el-menu-vertical-demo",
            collapse: ($setup.isCollapse1 == 0 && !$setup.isWindow) || ($setup.isCollapse1 == 0 && $setup.isWindow),
            onOpen: _ctx.handleOpen,
            onClose: _ctx.handleClose,
            style: {"border-right":"none","height":"100%","width":"fit-content"},
            "active-text-color": "#ffd04b",
            "background-color": "#000000",
            "text-color": "#fff",
            "default-active": $setup.defaultActive
          }, {
            default: _withCtx(() => [
              _createTextVNode("> "),
              _createVNode(_component_el_sub_menu, { index: "1" }, {
                title: _withCtx(() => [
                  _createVNode(_component_el_icon, { style: {"margin-right":"8px"} }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _hoisted_7
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/console",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.navigateTo('/console')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createTextVNode("控制台 ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.navigateTo('/userLog'))),
                        index: "/userLog"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createTextVNode("用户日志 ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.navigateTo('/dockKey'))),
                        index: "/dockKey"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _createTextVNode("对接API ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.navigateTo('/withdrawal'))),
                        index: "/withdrawal"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createTextVNode("提现记录")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "/agentEmpower",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.navigateTo('/agentEmpower')))
              }, {
                title: _withCtx(() => [
                  _createTextVNode("代理中心")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { style: {"margin-right":"8px"} }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              ($setup.user_conf.uid == 1000)
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 0,
                    index: "/userManage",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.navigateTo('/userManage')))
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode("用户管理")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { style: {"margin-right":"8px"} }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.user_conf.uid == 1000)
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: "/admin/withdrawal",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.navigateTo('/admin/withdrawal')))
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode("提现管理")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { style: {"margin-right":"8px"} }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ($setup.user_conf.uid == 1000)
                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 2,
                    index: "6"
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_component_el_icon, { style: {"margin-right":"8px"} }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }),
                      _hoisted_16
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_menu_item, {
                            index: "/develop",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.navigateTo('/develop')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17,
                              _createTextVNode("数据概览 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.navigateTo('/productManage'))),
                            index: "/productManage"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18,
                              _createTextVNode("产品管理 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.navigateTo('/versionLog'))),
                            index: "/VersionLog"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19,
                              _createTextVNode("版本管理 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.navigateTo('/NoticeManage'))),
                            index: "/NoticeManage"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20,
                              _createTextVNode("公告管理 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.navigateTo('/DataManage'))),
                            index: "/DataManage"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21,
                              _createTextVNode("数据管理 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_sub_menu, { index: "7" }, {
                title: _withCtx(() => [
                  _createVNode(_component_el_icon, { style: {"margin-right":"8px"} }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }),
                  _hoisted_23
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/CarmineList",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.navigateTo('/CarmineList')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _createTextVNode("卡密列表 ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.navigateTo('/CarmineUse'))),
                        index: "/CarmineUse"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createTextVNode("使用卡密 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "/freeBenefits",
                onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.navigateTo('/freeBenefits')))
              }, {
                title: _withCtx(() => [
                  _createTextVNode("免费授权")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { style: {"margin-right":"8px"} }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "/query",
                onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.navigateTo('/query')))
              }, {
                title: _withCtx(() => [
                  _createTextVNode("授权查询")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { style: {"margin-right":"8px"} }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "10",
                onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.openDialog('消息', '您确认要退出登录吗', true, 'outLogin')))
              }, {
                title: _withCtx(() => [
                  _createTextVNode("退出登录")
                ]),
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["collapse", "onOpen", "onClose", "default-active"]),
          _createVNode(_component_el_dialog, {
            modelValue: $setup.centerDialog.isShow,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.centerDialog.isShow) = $event)),
            title: $setup.centerDialog.title,
            width: "500",
            "align-center": ""
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_el_button, {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.centerDialog.isShow = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("关闭")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.centerDialogClick($setup.centerDialog.clickBind)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 确认 ")
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString($setup.centerDialog.content), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "title"])
        ]))
      : _createCommentVNode("", true)
  ]))
}